var map = {
	"./Angels.png": 447,
	"./Astros.png": 448,
	"./Athletics.png": 449,
	"./Blue Jays.png": 450,
	"./Braves.png": 451,
	"./Brewers.png": 452,
	"./Cardinals.png": 453,
	"./Cubs.png": 454,
	"./Diamondbacks.png": 455,
	"./Dodgers.png": 456,
	"./Giants.png": 457,
	"./Guardians.png": 458,
	"./Mariners.png": 459,
	"./Marlins.png": 460,
	"./Mets.png": 461,
	"./Nationals.png": 462,
	"./Orioles.png": 463,
	"./Padres.png": 464,
	"./Phillies.png": 465,
	"./Pirates.png": 466,
	"./Rangers.png": 467,
	"./Rays.png": 468,
	"./Red Sox.png": 469,
	"./Reds.png": 470,
	"./Rockies.png": 471,
	"./Royals.png": 472,
	"./Tigers.png": 473,
	"./Twins.png": 474,
	"./White Sox.png": 475,
	"./Yankees.png": 476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;